<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
export let layoutType = undefined;
export let videoUrl = undefined;
export let thumbUrl = undefined;
</script>

<BaseAtom _isotope="NVPlayVideoPlayerAtom" {...container}>
  <div>NVPlayVideoPlayerAtom</div>
</BaseAtom>
